<h2 *ngIf="message">{{ message }}</h2>
<div class="rating">
  <span *ngIf="showNumber"
    ><strong>{{ _rating }}</strong></span
  >
  <i *ngFor="let icon of stars" [class]="icon"></i>
</div>
